import { Redacted, Schema } from "effect";
import { privateDependencyFailure } from "@workerstation/shared/errors/private-cause";

export const chatScrollBottomThreshold = 24;
export const ChatScrollMetrics = Schema.Struct({
  scrollHeight: Schema.Finite,
  scrollTop: Schema.Finite,
  clientHeight: Schema.Finite
});
export const ChatScrollSnapshot = Schema.Struct({ following: Schema.Boolean, error: Schema.NullOr(Schema.String) });
export type ChatScrollSnapshot = typeof ChatScrollSnapshot.Type;
export class ChatScrollFailure extends privateDependencyFailure<ChatScrollFailure>()("ChatScrollFailure", "chat-scroll") {}
export const chatScrollFailure = (cause: unknown) => new ChatScrollFailure({ cause: Redacted.make(cause) });
